import type { Transaction } from "@rocicorp/zero";
import { userFacingError } from "../authorization";
import { type Schema, zql } from "../generatedDrizzleSchema";

export async function applyToolResult(
  tx: Transaction<Schema>,
  args: { chatId: string; entryId: string; isError?: boolean }
) {
  const [entry] = await tx.run(
    zql.chatEntries.where("id", args.entryId).where("chatId", args.chatId)
  );
  if (!entry) throw userFacingError(`Entry not found: ${args.entryId}`);

  const [toolCallEntry] = await tx.run(
    zql.toolCalls.where("entryId", args.entryId)
  );
  if (!toolCallEntry) {
    throw userFacingError(`Tool call not found: ${args.entryId}`);
  }

  await tx.mutate.toolCalls.update({
    entryId: toolCallEntry.entryId,
    isError: args.isError ?? false,
    completedAt: Date.now(),
  });
}
